export default __webpack_public_path__ + "static/media/jnk_logo.a4c9c572.png";